export default {
  welcome: '欢迎',
  home: '主页',
  'dashboard.title': '仪表盘',
  'dashboard.analysis': '分析页',
  'form.title': '表单页',
  'form.basic-form': '基础表单',
  'form.step-form.title': '分步表单',
  'form.step-form.info': '分步表单（填写转账信息）',
  'form.step-form.confirm': '分步表单（确认转账信息）',
  'form.step-form.result': '分步表单（完成）',
  'form.advanced-form': '高级表单',
  'list.title': '列表页',
  'list.table-list': '查询表格',
  'list.basic-list': '标准列表',
  'list.card-list': '卡片列表',
  'list.search-list.title': '搜索列表',
  'list.search-list.articles': '搜索列表（文章）',
  'list.search-list.projects': '搜索列表（项目）',
  'list.search-list.applications': '搜索列表（应用）',
  'result.title': '结果页',
  'result.success': '成功页',
  'result.fail': '失败页',
  'exception.title': '异常页',
  'exception.not-permission': '403',
  'exception.not-find': '404',
  'exception.server-error': '500',
  'exception.trigger': '触发错误',
  'account.title': '个人页',
  'account.center': '个人中心',
  'account.settings': '个人设置',
  'account.trigger': '触发报错',
  'account.logout': '退出登录',

  'shop.title': '店铺信息',
  'shop.shopMan': '店铺信息',
  'shop.shopType': '门店类型',
  'material.title': '资料管理',
  'material.index': '模板资料',
  'material.article.list': '文章资料',
  'system.title': '系统管理',
  'system.character': '角色管理',
  'system.member': '人员管理',
  'system.company': '公司管理',
  'system.systemLog': '系统日志',
  'system.dictionary': '数据字典',
  'system.memberUpload': '导入记录',
  'quotation.title': '报价管理',
  'quotation.model': '报价模型',
  'quotation.record': '报价记录',
  'quotation.recordDetail': '报价详情',
  'consultation.management': '咨询管理',
  'user.management': '用户管理',
  'user.managementDetail': '用户详情',
  'material.article.add': '新增文章',
  'material.article.detail': '文章详情',
  'material.article.edit': '修改文章',
  'consultation.add': '新增咨询',
  'consultation.detail': '咨询详情',

  'ticket.management': '门票管理',
  'ticket.add': '新增门票',
  'ticket.edit': '编辑门票',
  'ticket.detail': '门票详情',
  'ticket.session': '配置场次',

  'order.management': '订单管理',
  'order.detail': '订单详情',

  'artist.management': '艺术家介绍',
  'artist.add': '新增艺术家',
  'artist.edit': '编辑艺术家'
}
